export const requestStatusColorClass: Record<string, string> = {
  default: "ongoing",
  submitted: "ongoing",
  "in-progress": "ongoing",
  recommended: "recommended",
  "recommended-by-mail": "recommended",
  booked: "booked",
  closed: "closed",
  cancelled: "cancelled",
  "proposal-validated": "done",
  "proposal-rejected": "modifying",
  "cancellation-requested": "cancelled",
  "modification-requested": "modifying",
  "validated": "done",
  "rejected": "cancelling",
};

export const accessibleRequestFields: Record<string, string> = {
  "additional_information_digital": "JP-Star",
  "location": "JP-Position",
  "start_location": "JP-Position",
  "end_location": "JP-Location",
  "start_date": "JP-Calendar",
  "end_date": "JP-Calendar",
  "participants": "JP-User",
  "max_budget": "JP-Credit-card",
  "number_of_rooms": "JP-Bed",
  "category_class": "JP-Collection-tag",
  "description": "JP-Plus",
};

export const serviceIcons: Record<string, string> = {
  "tours": "JP-Luggage",
  "accommodation": "JP-Bed",
  "dining": "JP-Fork-spoon",
  "gourmet": "JP-Fork-spoon",
  "arts-entertainment": "JP-Ticket",
  "sports-events": "JP-Ticket",
  "transportation": "JP-Plane",
  "daily-services": "JP-Home-2",
  "shopping": "JP-Shopping-bag",
  "ground-transfer": "JP-Taxi",
  "bars-club": "JP-Cold-drink",
  "food-beverage": "JP-Fork-spoon",
  "personal-services": "JP-Service",
  "home-services": "JP-Home-2",
  "member-support": "JP-Headset",
  "travelers-services": "JP-Suitcase",
  "assistance": "JP-First-aid-kit",
  "banking": "JP-Credit-card",
  "formalities": "JP-Document",
  "event-planning": "JP-Calendar",
  "insurance": "JP-Shield",
  "member-activation": "JP-Key",
  "member-engagement": "JP-Heart",
  "sports-wellness": "JP-Medal",
  "vehicle-logistics": "JP-Van",
  "repair-maintenance": "JP-Set-up",
};

export const subFamilyIcons: Record<string, string> = {
  "car-rental": "JP-Taxi",
  "car-vehicle-rental": "JP-Taxi",
  "taxi": "JP-Taxi",
  "car-service": "JP-Taxi",
};
